import { render, staticRenderFns } from "./detail9.vue?vue&type=template&id=4fefcc10&scoped=true"
import script from "./detail9.vue?vue&type=script&lang=js"
export * from "./detail9.vue?vue&type=script&lang=js"
import style0 from "./detail9.vue?vue&type=style&index=0&id=4fefcc10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fefcc10",
  null
  
)

export default component.exports